export const themes = {
    white: '#fff',
    dark: '#25273c',
    darker: '#181824',
    darketst: '#181817',
    lightGray: 'rgb(207 207 217)',
    lighterDark: '#2e3251',
}

export const fontSizes = {
    h1 : '3rem',
    h2 : '2.5rem',
    h3 : '1.8rem',
    p : '1rem',
}